export const COMPOSE_PREFILL_KEY = "mailcraft:compose-prefill";

export type ComposePrefill = {
  to: string;
  cc: string;
  bcc: string;
  subject: string;
  html: string;
  text: string;
  sourceLogId: number;
};
